module.exports = __webpack_public_path__ + "img/system_img.51271d79.png";